import React from 'react';
import { PsPage } from '../../../../shared/components/ps-page/PsPage';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import WorkRecentlyAddedCard from '../../../../works/components/WorkRecentlyAddedCard';
import AddWorkCard from '../../../../works/components/AddWorkCard';
import ImportWorksCard from '../../../../works/components/ImportWorksCard';
import Row from '../../../../shared/components/Row';
import { connect } from 'react-redux';
import { CurrentUser } from '../../../../shared/model/CurrentUser';
import { BreadcrumbsManagerInstance } from '../../../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../../../shared/breadcrumbs/Breadcrumbs';

class WorkCreate extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.MY_OUTSOURCES,
            Breadcrumbs.MY_OUTSOURCES_WORKS,
            Breadcrumbs.MY_OUTSOURCES_WORKS_ADD,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    render() {
        const { breadcrumbs } = this.state;
        const { currentUser } = this.props;

        return (
            <PsPage title={I18nUtils.tr('TR_MI_NUEVA_OBRA')} breadcrumbs={breadcrumbs}>
                <Row clearfix>
                    <AddWorkCard/>
                    {
                        currentUser.hasAPI() ? <ImportWorksCard/> : null
                    }
                    <WorkRecentlyAddedCard/>
                </Row>
            </PsPage>
        );
    }

}

const mapStateToProps = (state) => {
    return ( { currentUser: CurrentUser.fromReduxState(state) } );
};

export const WorkCreateScreen = connect(mapStateToProps)(WorkCreate);



// WEBPACK FOOTER //
// ./src/app/my-outsources/work/form/create/WorkCreateScreen.jsx